import { CountryCode, parsePhoneNumber } from "libphonenumber-js";

export const formatPhoneByCountry = (
  phone: string,
  countryCode?: string | null
) => {
  return parsePhoneNumber(
    phone,
    (countryCode as CountryCode) || "US"
  ).formatInternational();
};
